import { type InputHTMLAttributes, forwardRef } from 'react'
import { cn } from '@/shared/utils/cn'

export type InputProps = InputHTMLAttributes<HTMLInputElement>

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, type = 'text', ...props }, ref) => (
    <input
      ref={ref}
      type={type}
      className={cn(
        'flex h-10 w-full rounded-lg border border-line bg-panel px-3 text-sm text-ink placeholder:text-ink-subtle',
        'transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand/50 focus-visible:border-brand',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'aria-[invalid=true]:border-danger aria-[invalid=true]:focus-visible:ring-danger/40',
        className,
      )}
      {...props}
    />
  ),
)
Input.displayName = 'Input'
